import { Injectable } from '@angular/core';
import { SERVICE_STATUS_CODES } from 'src/app/shared/common/constants';
import { IRentability } from 'src/app/shared/interfaces/rentability.interface';
import { GlobalStorage } from '../../core/services/globals.service';
import { BffService } from '../../core/services/http/bff.http.service';
import { toClpPlusDecimals } from '../../core/utils/formatters';
import {
  IEmployerLookupResult,
  IEmployerRawFromService,
  ISubscriptionRequest,
  ISubscriptionResult,
} from '../models/subscription-api.model';

@Injectable({ providedIn: 'root' })
export class SubscriptionApiService {
  private ufRequest?: Promise<string>;

  constructor(
    private readonly bff: BffService,
    private readonly globalSvc: GlobalStorage
  ) {}

  getCurrentUf(): Promise<string> {
    this.ufRequest ??= this.bff
      .getCurrentUf()
      .then((res) => toClpPlusDecimals(String(res.data.data.result[0].monto)))
      .catch((error) => {
        this.ufRequest = undefined;
        throw error;
      });

    return this.ufRequest;
  }

  async getRentability(): Promise<IRentability[]> {
    if (this.globalSvc.rentability.length === 0) {
      const res = await this.bff.getRentability();
      this.globalSvc.rentability = res.data.data.result as IRentability[];
    }

    return this.globalSvc.rentability;
  }

  async getEmployers(): Promise<IEmployerRawFromService[]> {
    const res = await this.bff.getEmployersByRut();

    return (res.data.data.result ?? []) as IEmployerRawFromService[];
  }

  async findEmployer(rut: string): Promise<IEmployerLookupResult | null> {
    const res = await this.bff.getEmployerData(rut);
    const result = res.data.data?.result as IEmployerLookupResult | undefined;

    return result?.code === SERVICE_STATUS_CODES.OK ? result : null;
  }

  async submit(request: ISubscriptionRequest): Promise<ISubscriptionResult> {
    const res = await this.bff.submitSubscription(request);
    const status = res.data.data.status.data.status;

    return { folio: status.Suscripcion[0].folio, pdf: status.pdf };
  }
}
